import { HttpResult } from 'widgets-for-react'
import {
  ComplianceResponse,
  MerchantResponse,
  UidObject
} from '../types/online_payment_platform'
import { getCsrfToken } from '../utils/csrf'
import { prefixUrlWithLocale } from '../utils/url'

export async function getMerchant(
  id: number
): Promise<HttpResult<MerchantResponse>> {
  const res = await fetch(
    prefixUrlWithLocale(`/api/opp/users/${id}/merchants`),
    { cache: 'no-store' }
  )
  if (!res.ok) {
    return { kind: 'failed', status: res.status }
  }
  const merchant = (await res.json()) as MerchantResponse
  return { kind: 'result', value: merchant, status: 200 }
}

export async function getCompliance(
  id: number
): Promise<HttpResult<ComplianceResponse>> {
  const res = await fetch(
    prefixUrlWithLocale(`/api/opp/users/${id}/merchants/compliance`),
    { cache: 'no-store' }
  )
  if (!res.ok) {
    return { kind: 'failed', status: res.status }
  }
  const compliance = (await res.json()) as ComplianceResponse
  return { kind: 'result', value: compliance, status: 200 }
}

export async function createBankAccount(
  id: number
): Promise<HttpResult<UidObject>> {
  const res = await fetch(
    prefixUrlWithLocale(`/api/opp/users/${id}/bank_accounts`),
    {
      method: 'post',
      body: JSON.stringify({
        owner_id: id
      }),
      headers: [
        ['Content-Type', 'application/json'],
        ['Accept', 'application/json'],
        ['X-CSRF-Token', getCsrfToken()]
      ]
    }
  )
  if (res.ok) {
    const value = (await res.json()) as UidObject
    return { kind: 'result', value, status: 200 }
  } else {
    return { kind: 'failed', status: res.status }
  }
}
